export default __webpack_public_path__ + "static/media/skip.f7e009a3.svg";